import angular from 'angular';
import pako from 'pako';

import config from '../../config.js';

class PrintService {
  constructor(Authentication, SlingAnalytics) {
    'ngInject';

    Object.assign(this, { Authentication, SlingAnalytics });

    this.invoiceFormElement = angular.element(`
      <form action="${this.Authentication.baseUrl}account/org/invoice/print" method="post" target="_blank" style="display: none;">
        <textarea name="invoiceid"></textarea>
        <input name="token" value="${Authentication.token}" />
      </form>
    `);
    angular.element(document.body).append(this.invoiceFormElement);
    this.invoiceIdField = this.invoiceFormElement[0].children[0];

    this.headlessFormElement = angular.element(`
      <form action="${
        config.HEADLESS_PRINT_URL
      }" method="post" target="_blank" style="display: none;">
        <textarea name="payload"></textarea>
        <input name="route" />
        <input name="staging" value="${__STAGING__ ? 'true' : 'false'}" />
        <input name="waitForGlobalLinker" value="true" />
      </form>
    `);
    angular.element(document.body).append(this.headlessFormElement);

    if (config.HEADLESS_BATCH_PRINT_URL) {
      this.headlessBatchFormElement = angular.element(`
        <form action="${config.HEADLESS_BATCH_PRINT_URL}" method="post" target="_blank" style="display: none;">
          <textarea name="payload"></textarea>
        </form>
      `);
      angular.element(document.body).append(this.headlessBatchFormElement);
    }

    this.headlessPayload = this.headlessFormElement[0].children[0];
    this.headlessRoute = this.headlessFormElement[0].children[1];

    this.headlessBatchPayload = this.headlessBatchFormElement?.[0].children[0];
  }

  _compressPayload = (json) => {
    const deflated = pako.deflate(json);

    return JSON.stringify({
      data: [...deflated],
      compressedWithPako: true,
    });
  };

  _getBatchPayload = ({ prepareResult, ...rest } = {}) => {
    if ('$replacer' in prepareResult && !prepareResult.$replacer) {
      throw new Error('[PrintService] passed empty $replacer!');
    }

    const { $replacer, $route, $filenameSuffix, ...payload } = prepareResult;
    Object.assign(payload, rest);

    return {
      payload: this._compressPayload(JSON.stringify(payload, $replacer ?? null)),
      filenameSuffix: $filenameSuffix,
      route: $route,
      staging: __STAGING__,
      waitForGlobalLinker: true,
    };
  };

  printHeadless({ prepareResult, ...rest } = {}, isLocalPreview) {
    if ('$replacer' in prepareResult && !prepareResult.$replacer) {
      throw new Error('[PrintService] passed empty $replacer!');
    }

    const { $replacer, $route, ...payload } = prepareResult;
    Object.assign(payload, rest);

    if ($route.includes('reports/')) {
      const reportName = $route.replace('reports/', '');

      const { reportPrinted } = this.SlingAnalytics.analyticsEvents;
      this.SlingAnalytics.track(reportPrinted, reportName);
    }

    this.headlessRoute.value = $route;

    this.headlessPayload.value = this._compressPayload(JSON.stringify(payload, $replacer ?? null));

    if (isLocalPreview) {
      return [this.headlessPayload.value, this.headlessRoute.value];
    }

    this.headlessFormElement[0].submit();
  }

  printBatchHeadless(data) {
    if (!this.headlessBatchFormElement) {
      throw new Error('[PrintService] batch printing unavailable');
    }

    this.headlessBatchPayload.value = JSON.stringify(data.map(this._getBatchPayload));
    this.headlessBatchFormElement[0].submit();
  }

  printInvoice(invoiceId) {
    this.invoiceIdField.value = invoiceId;
    this.invoiceFormElement[0].submit();
  }
}

export default PrintService;
